export default __webpack_public_path__ + "static/media/amex_logo.c0b09f48.svg";